import * as React from "react";
import { Unsubscribe } from "redux";
import { Button, SpinnerLoader } from "scuid-x";
import { DocDesc } from "../components/DocDesc";
import { DocExampleCarousel } from "../components/DocExampleCarousel";
import { DocTips } from "../components/DocTips";
import { HeaderAndFooter } from "../components/HeaderAndFooter";
import { DocType, getFirstDoc } from "../constants/DocType";
import { Measurement, MeasurementEvents } from "../constants/Measurement";
import { Routes } from "../constants/Routing";
import { DcStore } from "../stores/DcStore";
import "./Landing.css";
import {proxyOptimizelyEventTracking} from "../constants/ApiCalls";
import {DOC_CAPTURE_PAGE_LANDED_EVENT} from "../constants/Experiments";

export interface LandingProps {
  uuid?: string;
  appId?: string;
  coBorrower: string | null;
  docType?: string;
}

export interface LandingState {
  documents?: DocType[];
  store: DcStore;
}

export class Landing extends React.Component<LandingProps, LandingState> {
  private unsubscribe: Unsubscribe;
  private scrollFired = false;
  private clickFired = false;

  constructor(props: LandingProps) {
    super(props);
    const store = new DcStore();
    this.unsubscribe = store.subscribe(() => this.onStoreChange());
    this.state = {
      documents: store.getState().documents,
      store,
    };
  }

  public render() {
    const documents = this.state.documents;

    if (!documents || documents.length === 0) {
      return <SpinnerLoader isFullPage={true}/>;
    }

    const firstDoc = getFirstDoc(documents);
    return (
      <HeaderAndFooter>
        <div className={"landingScreen"}>
          <h2>Welcome to instant verify!</h2>
          <DocDesc docType={firstDoc}/>
          <DocExampleCarousel
            docType={firstDoc}
          />
          <DocTips
            docType={firstDoc}
          />
          <Button
            className={"landingScreen-take-photo-button"}
            onClick={this.buttonPressHandler}
          >
            Continue
          </Button>
        </div>
      </HeaderAndFooter>
    );
  }

  public componentDidMount() {
    proxyOptimizelyEventTracking(
        this.props.uuid,
        this.props.appId,
        DOC_CAPTURE_PAGE_LANDED_EVENT,
        this.props.coBorrower
    );
    this.state.store.apiActions.getReqDocs(this.props.uuid, this.props.appId,
        this.props.coBorrower, true, null, true);
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("dragstart", this.onScroll);
    window.addEventListener("click", this.onClick);
    window.addEventListener("visibilitychange", this.onVisibilityChange);
    window.addEventListener("pagehide", this.onLeave);
  }

  public componentWillUnmount() {
    this.unsubscribe();
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("dragstart", this.onScroll);
    window.removeEventListener("click", this.onClick);
    window.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.removeEventListener("pagehide", this.onLeave);
  }

  public onScroll = () => {
    if (!this.scrollFired) {
      Measurement.fireEvent(MeasurementEvents.DOC_CAP_SCROLL_LAND);
      this.scrollFired = true;
    }
  };

  public onClick = () => {
    if (!this.clickFired) {
      Measurement.fireEvent(MeasurementEvents.DOC_CAP_CLICK_LAND);
      this.clickFired = true;
    }
  };

  public onLeave = () => {
    Measurement.fireEvent(MeasurementEvents.DOC_CAP_BACK_LAND);
  };

  public onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      Measurement.fireEvent(MeasurementEvents.DOC_CAP_INACT_LAND);
    } else if (document.visibilityState === "visible") {
      Measurement.fireEvent(MeasurementEvents.DOC_CAP_ACT_LAND);
    }
  };

  private onStoreChange() {
    const documents = this.state.store.getState().documents;
    if (this.state.documents !== documents) {
      this.setState({
        documents,
      });
    }
  }

  private buttonPressHandler = () => {
    Routes.goToUpload(this.props.uuid, this.props.appId, this.props.docType);
  }
}



// WEBPACK FOOTER //
// ./src/screens/Landing.tsx